import React, { useState, useEffect } from 'react';

import styled from 'styled-components';
//import MemberTable from '../common/MemberTable';
import { Ring } from 'react-awesome-spinners';
import { timeValueToDate } from '../../lib/commonFunc/commonFunc'
import { ReactComponent as FaceIcon } from '../../resources/images/svg/face.svg';
import Select from 'react-select';
import palette from '../../lib/styles/palette';
import Pagination from '@material-ui/lab/Pagination';
import { GoSearch } from 'react-icons/go';
import { MdRefresh, MdSmartphone, MdTune, MdClose } from 'react-icons/md';

const MemberShipTilte = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    margin-left: 5px;
    color: ${palette.webCyan[5]};
    font-size: 1.4rem;
  }
`;
const MemberBlock = styled.div`
  margin-top: 2.5rem;
`;
const ButtonBlock = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const Filter = styled.div`
  display: flex;
  align-items: stretch;
`;
const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const FilterDivider = styled.div`
  width: 1px;
  align-self: stretch;
  margin: 2px 24px;
  background: ${palette.webGray[13]};
`;
const FilterGroupTitle = styled.div`
  font-size: 0.75rem;
  font-weight: 800;
  color: ${palette.webGray[6]};
  letter-spacing: 0.04em;
`;
const FilterFields = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 10px;
`;
const FilterField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;
const FilterLabel = styled.span`
  font-size: 0.72rem;
  font-weight: 700;
  color: ${palette.webGray[7]};
  letter-spacing: 0.02em;
  padding-left: 2px;
`;
const GoToPageButton = styled.button`
  padding: 6px 10px;
  border-radius: 4px;
  border: none;
  background: ${palette.webGray[15]};
  color: ${palette.webGray[7]};
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${palette.webGray[14]};
  }
`;
const TopMenu = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 15px;
`;
const FilterChip = styled.div`
  display: inline-flex;
  align-items: center;
  margin-bottom: 12px;
  padding: 6px 12px;
  border-radius: 16px;
  background: ${palette.webGray[15]};
  color: ${palette.webGray[6]};
  font-size: 0.9rem;
`;
const MemberTable = styled.table`
  width: 100%;
  text-align: center;
  table-layout: fixed;
`
const MemberTableHeader = styled.thead`
  width: 100%;
  border-top: 1px solid ${palette.webGray[5]};
  border-bottom: 1px solid ${palette.webGray[5]};

  & tr{
    cursor: default;
    & td{
      font-weight: bold;
      padding: 12px 10px;
    }
  }
`

const MemberTableBody = styled.tbody`
  width: 100%;
  & tr {
    cursor: pointer;
    width: 100%;
    &:hover {
      background-color: ${palette.webGray[15]};
    }
  }
  
  & td {    
    font-size: .95rem;
    border-bottom: 1px solid ${palette.webGray[17]};
    text-overflow:ellipsis; 
    overflow:hidden; 
    white-space:nowrap;
  }
  
  & td:nth-child(1) {    
    color: ${palette.webCyan[5]};
  }
`
const ModalBlock = styled.div`
  width: 100%;
  height: 100%;
  z-index: 999;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`
const ModalBackground = styled.div`
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .4);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
`
const Modal = styled.form`
  position: relative;
  width: 180px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 15px;
  box-sizing: border-box;
  border: 1px solid ${palette.webGray[15]};
  border-radius: 5px;
  box-shadow: 0px 7px 7px 0px rgba(0,0,0, .2);
  z-index: 2;

  & input {
    width: 100%;
    padding: 7px 8px;
    box-sizing: border-box;
    font-size: .95rem;
    border: 1px solid ${palette.webGray[15]};
    border-radius: 5px;
    &:focus {
      outline: none;
    }
  }
  & input.warn {
    border: 1px solid rgba(240, 15, 15, .3);
  }
`
const ModalBtnBox = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  & button {
    width: 48%;
    font-size: .95rem;
    margin-top: 1rem;
    border-radius: 5px;
    background-color: ${palette.webCyan[5]};
    color: #fff;
    padding: 3px 0px;
    cursor: pointer;
    border: none;
    &:focus {
      outline: none;
    }
  }
  & button:nth-child(2) {
    background-color: ${palette.webGray[10]};
  }
`
const WarnText = styled.p`
  width: 100%;
  color: ${palette.expired};
  font-size: 0.8rem;
  margin: 6px 0 0;
`;
const StateBox = styled.div`
  width: 100%;
  background-color: ${palette.valid};
  color: #fff;
  border-radius: 4px;
  padding: 3px  1px;
  text-overflow:ellipsis; 
  overflow:hidden; 
  white-space:nowrap;

  &.expiration {
  background-color: ${palette.expired};
  }
  &.holding {
  background-color: ${palette.hold};
  }
  &.waiting {
  background-color: ${palette.wait};
  }
`

// search part start 
const InputBlock = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  height: 100%;
`;
const StyledInput = styled.input`
  border: none;
  background: transparent;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  font-size: 1rem;
  padding-left: 1rem;

  &:focus {
    outline: none;
  }
`;
const StyledForm = styled.form`
  display: flex;
  align-items: center;
  width: 260px;
  height: 42px;
  box-sizing: border-box;
  background: #fff;
  border: 1px solid ${palette.webGray[4]};
  border-radius: 11px;
  overflow: hidden;

  & svg {
    cursor: pointer;
    color: ${palette.webCyan[5]};
    font-size: 1.5rem;
    margin: 0 12px;
  }
`;
// search part end

const customStyles = {
  menu: (provided, state) => ({
    ...provided,
    width: state.selectProps.width,
    borderBottom: '1px dotted pink',
    color: state.selectProps.menuColor,
    padding: 20,
    fontSize: '0.95rem',
    'z-index': 500,
  }),
  indicatorSeparator: (provided, state) => ({
    backgroundColor: 'none',
  }),
  indicatorContainer: (provided, state) => ({
    color: '#e2feff',
  }),
  input: () => ({
    curosr: 'pointer',
  }),
  control: (_, { selectProps: { width } }) => ({
    width: width,
    display: 'flex',
    color: '#fff',
    'z-index': 500,
    curosr: 'pointer',
    border: '1px solid #ccc',
    fontSize: '0.95rem',
    paddingLeft: '10px',
    borderRadius: '5px'
  }),
  placeholder: () => ({
    cursor: 'pointer',
    color: '#e2feff',
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';

    return { ...provided, opacity, transition };
  },
};

const options = [
  { label: '가입일 순', value: 'registTime' },
  { label: '이름 순', value: 'name' },
  { label: '나이 순', value: 'birth' },
];

const stateOptions = [
  { label: '전체', value: '' },
  { label: '유효', value: '1' },
  { label: '만료', value: '2' },
  { label: '대기', value: '3' },
  { label: '홀드', value: '4' },
];

const sexOptions = [
  { label: '전체', value: '' },
  { label: '남자', value: '1' },
  { label: '여자', value: '2' },
];

/* ===== Refined member filter : toolbar + modal ===== */
const Toolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
`;
const ToolbarLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  flex: 1;
  min-width: 0;
`;
const ToolbarRight = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
`;

// 툴바 버튼 공통 — FilterButton/검색창과 동일한 42px 라인에 맞춤
const ToolbarBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 42px;
  padding: 0 18px;
  border-radius: 11px;
  font-size: 0.95rem;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.18s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  border: 1px solid ${(p) => (p.primary ? palette.webCyan[5] : palette.webGray[3])};
  background: ${(p) => (p.primary ? palette.webCyan[5] : '#fff')};
  color: ${(p) => (p.primary ? '#fff' : palette.webGray[7])};

  &:hover {
    border-color: ${palette.webCyan[5]};
    box-shadow: 0 4px 14px rgba(26, 115, 233, 0.14);
    ${(p) => (p.primary ? 'filter: brightness(1.05);' : `color: ${palette.webCyan[5]};`)}
  }
  &:focus {
    outline: none;
  }
`;

const ToolbarIconBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 11px;
  border: 1px solid ${palette.webGray[3]};
  background: #fff;
  color: ${palette.webGray[7]};
  cursor: pointer;
  transition: all 0.18s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);

  & svg {
    font-size: 1.35rem;
  }
  &:hover {
    border-color: ${palette.webCyan[5]};
    color: ${palette.webCyan[5]};
    box-shadow: 0 4px 14px rgba(26, 115, 233, 0.14);
  }
  &:focus {
    outline: none;
  }
`;
const FilterButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 42px;
  padding: 0 16px;
  border: 1px solid ${(props) => (props.active ? palette.webCyan[5] : palette.webGray[3])};
  border-radius: 11px;
  background: ${(props) => (props.active ? 'rgba(26, 115, 233, 0.06)' : '#fff')};
  color: ${(props) => (props.active ? palette.webCyan[5] : palette.webGray[7])};
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.18s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);

  & svg {
    font-size: 1.25rem;
  }
  &:hover {
    border-color: ${palette.webCyan[5]};
    color: ${palette.webCyan[5]};
    box-shadow: 0 4px 14px rgba(26, 115, 233, 0.14);
  }
  &:focus {
    outline: none;
  }
`;
const CountBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 10px;
  background: ${palette.webCyan[5]};
  color: #fff;
  font-size: 0.74rem;
  font-weight: 700;
`;
const ChipRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;
const Chip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 34px;
  padding: 0 7px 0 13px;
  border-radius: 17px;
  background: rgba(26, 115, 233, 0.06);
  border: 1px solid rgba(26, 115, 233, 0.18);
  color: ${palette.webCyan[5]};
  font-size: 0.86rem;
  font-weight: 600;

  & .key {
    color: ${palette.webGray[6]};
    font-weight: 500;
  }
  & .remove {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 19px;
    height: 19px;
    border: none;
    background: transparent;
    color: ${palette.webGray[6]};
    cursor: pointer;
    border-radius: 50%;
    font-size: 0.95rem;
    transition: all 0.15s ease;
    &:hover {
      background: rgba(26, 115, 233, 0.15);
      color: ${palette.webCyan[5]};
    }
    &:focus {
      outline: none;
    }
  }
`;
const AppliedRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin: -6px 0 18px;
`;
const AppliedLabel = styled.span`
  font-size: 0.82rem;
  font-weight: 700;
  color: ${palette.webGray[6]};
`;
const FilterModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(17, 24, 39, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fmFade 0.15s ease;
  @keyframes fmFade {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;
const FilterModalCard = styled.div`
  width: 480px;
  max-width: 92vw;
  max-height: 86vh;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.28);
  animation: fmPop 0.18s ease;
  @keyframes fmPop {
    from { transform: translateY(10px) scale(0.98); opacity: 0; }
    to { transform: none; opacity: 1; }
  }
`;
const FilterModalHeader = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: 22px 24px;
  border-bottom: 1px solid ${palette.webGray[1]};

  & h3 {
    margin: 0;
    font-size: 1.18rem;
    font-weight: 800;
    color: ${palette.webGray[9]};
  }
  & .close {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border: none;
    background: transparent;
    color: ${palette.webGray[6]};
    font-size: 1.45rem;
    cursor: pointer;
    border-radius: 9px;
    transition: all 0.15s ease;
    &:hover {
      background: ${palette.webGray[1]};
      color: ${palette.webGray[8]};
    }
    &:focus {
      outline: none;
    }
  }
`;
const FilterModalBody = styled.div`
  flex: 1;
  min-height: 0;
  padding: 6px 24px;
  overflow-y: auto;
`;
const FilterSection = styled.div`
  padding: 14px 0;
`;
const SectionLabel = styled.div`
  font-size: 0.82rem;
  font-weight: 700;
  color: ${palette.webGray[7]};
  margin-bottom: 13px;
  letter-spacing: 0.01em;
`;
const SectionHint = styled.span`
  margin-left: 7px;
  font-size: 0.72rem;
  font-weight: 500;
  color: ${palette.webCyan[5]};
`;
const PillGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;
const MembershipPillGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  gap: 8px;
  max-height: 200px;
  overflow-y: auto;
  padding: 14px;
  border: 1px solid ${palette.webGray[3]};
  border-radius: 12px;
  background: ${palette.webGray[0]};

  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${palette.webGray[4]};
    border-radius: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
    margin: 8px 0;
  }
`;
const Pill = styled.button`
  height: 38px;
  padding: 0 16px;
  border-radius: 10px;
  border: 1px solid ${(props) => (props.selected ? palette.webCyan[5] : palette.webGray[3])};
  background: ${(props) => (props.selected ? palette.webCyan[5] : '#fff')};
  color: ${(props) => (props.selected ? '#fff' : palette.webGray[7])};
  font-size: 0.9rem;
  font-weight: ${(props) => (props.selected ? 700 : 500)};
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    border-color: ${palette.webCyan[5]};
    color: ${(props) => (props.selected ? '#fff' : palette.webCyan[5])};
  }
  &:focus {
    outline: none;
  }
`;
const FilterModalFooter = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 12px;
  padding: 16px 24px 22px;
  border-top: 1px solid ${palette.webGray[1]};
`;
const ResetButton = styled.button`
  height: 46px;
  padding: 0 20px;
  border-radius: 11px;
  border: 1px solid ${palette.webGray[3]};
  background: #fff;
  color: ${palette.webGray[7]};
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  &:hover {
    background: ${palette.webGray[0]};
  }
  &:focus {
    outline: none;
  }
`;
const ApplyButton = styled.button`
  flex: 1;
  height: 46px;
  border-radius: 11px;
  border: none;
  background: ${palette.webCyan[5]};
  color: #fff;
  font-size: 0.98rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.15s ease;
  box-shadow: 0 6px 16px rgba(26, 115, 233, 0.3);
  &:hover {
    filter: brightness(0.96);
  }
  &:focus {
    outline: none;
  }
`;

const MemberList = ({
  clubMemberList,
  loading,
  onClick,
  onRegist,
  onChangeSelect,
  modal,
  modalHandler,
  onChangePage,
  inputPage,
  page,
  onSubmit,
  onChange,
  onClickSearch,
  form,
  getAllUsers,
  clubLessonInfoData,
  memberCount,
  setPage,
  setInputPage,
  type,
  faceActive,
  searchKeyword,
  membershipTitles,
  membershipTitle,
  onChangeMembershipTitle,
  memberState,
  onChangeMemberState,
  sex,
  onChangeSex,
}) => {
  const [warn, setWarn] = useState(false)
  const [text, setText] = useState(searchKeyword || "")
  const maxPage = Math.max(1, Math.ceil((memberCount || 0) / 20));

  // 회원 필터 모달 (정렬/성별/상태/회원권 종류) — 모달 내에서 임시 선택 후 '적용' 시 일괄 반영
  // 회원권 종류는 다중 선택: 적용 시 JSON 배열 문자열로 전달, 미선택이면 '' (전체)
  const parseTitles = (val) => {
    if (!val) return []
    try { const p = JSON.parse(val); return Array.isArray(p) ? p : [String(p)] }
    catch (e) { return [val] }
  }
  const [filterOpen, setFilterOpen] = useState(false)
  const [draftSort, setDraftSort] = useState(type || 'registTime')
  const [draftSex, setDraftSex] = useState(sex || '')
  const [draftTitles, setDraftTitles] = useState(parseTitles(membershipTitle))
  const [draftState, setDraftState] = useState(memberState || '')

  const openFilter = () => {
    // 현재 적용된 값으로 초안 동기화 후 모달 오픈
    setDraftSort(type || 'registTime')
    setDraftSex(sex || '')
    setDraftTitles(parseTitles(membershipTitle))
    setDraftState(memberState || '')
    setFilterOpen(true)
  }
  const applyFilter = () => {
    if (onChangeSelect) onChangeSelect(options.find((o) => o.value === draftSort) || options[0])
    if (onChangeSex) onChangeSex(draftSex)
    if (onChangeMembershipTitle) onChangeMembershipTitle(draftTitles.length ? JSON.stringify(draftTitles) : '')
    if (onChangeMemberState) onChangeMemberState(draftState)
    setFilterOpen(false)
  }
  const resetDraft = () => {
    setDraftSort('registTime')
    setDraftSex('')
    setDraftTitles([])
    setDraftState('')
  }

  useEffect(() => {
    const next = searchKeyword || '';
    setText((prev) => (prev === next ? prev : next));
  }, [searchKeyword])

  const openGoToPageModal = () => {
    setWarn(false);
    setInputPage(String(page));
    modalHandler();
  };

  const handlePageInputChange = (e) => {
    setWarn(false);
    const value = e.target.value.replace(/[^0-9]/g, '');
    setInputPage(value);
  };

  const handleModalSubmit = (e) => {
    e.preventDefault();
    const target = Number(inputPage);
    if (!Number.isFinite(target) || target < 1 || target > maxPage) {
      setWarn(true);
      return;
    }
    if (target !== page) {
      setPage(target);
      onChangePage(target);
    }
    setWarn(false);
    modalHandler();
  };

  const classificationRepState = (repState) => {
    switch(repState) {
      case 1 : return <StateBox>유효</StateBox> ;
      case 2 : return <StateBox className="expiration">만료</StateBox> ;
      case 3 : return <StateBox className="waiting">대기</StateBox> ;
      case 4 : return <StateBox className="holding">홀드</StateBox> ;
      default : return "-" ;
    }
  }

  const membershipTitleOptions = [{ label: '전체', value: '' }].concat(
    Array.isArray(membershipTitles)
      ? membershipTitles.map((t) => ({ label: t, value: t }))
      : []
  );
  const curMembershipTitle = membershipTitleOptions.find((o) => o.value === (membershipTitle || ''));
  const curMemberState = stateOptions.find((o) => o.value === (memberState || ''));
  const curSex = sexOptions.find((o) => o.value === (sex || ''));

  const list = Array.isArray(clubMemberList) ? clubMemberList : [];

  // 현재 "적용된" 필터를 칩으로 표시 (기본값이 아닌 것만), 각 칩은 개별 제거 가능
  const activeChips = [];
  if (type && type !== 'registTime') {
    const o = options.find((x) => x.value === type);
    activeChips.push({ key: '정렬', text: o ? o.label : type, clear: () => onChangeSelect && onChangeSelect(options[0]) });
  }
  if (sex && sex !== '') {
    const o = sexOptions.find((x) => x.value === sex);
    activeChips.push({ key: '성별', text: o ? o.label : sex, clear: () => onChangeSex && onChangeSex('') });
  }
  parseTitles(membershipTitle).forEach((t) => {
    activeChips.push({ key: '회원권', text: t, clear: () => {
      const remaining = parseTitles(membershipTitle).filter((x) => x !== t);
      onChangeMembershipTitle && onChangeMembershipTitle(remaining.length ? JSON.stringify(remaining) : '');
    } });
  });
  if (memberState && memberState !== '') {
    const o = stateOptions.find((x) => x.value === memberState);
    activeChips.push({ key: '상태', text: o ? o.label : memberState, clear: () => onChangeMemberState && onChangeMemberState('') });
  }

  return (
    <MemberBlock>
      { modal? 
        <ModalBlock>
          <Modal onSubmit={handleModalSubmit}>
              <input
                type="number"
                value={inputPage}
                placeholder={`1 ~ ${maxPage}`}
                min="1"
                max={maxPage}
                className={warn ? 'warn' : ''}
                onChange={handlePageInputChange}
                autoFocus
              ></input>
              {warn && <WarnText>1부터 {maxPage} 사이의 페이지 번호를 입력해주세요.</WarnText>}
            <ModalBtnBox>
              <button type="submit">
                이동
              </button>
              <button type="button" onClick={() => {setWarn(false); modalHandler();}}>취소</button>
            </ModalBtnBox>
          </Modal>
          <ModalBackground onClick={() => {setWarn(false); modalHandler();}} />
        </ModalBlock>
      : ""}
      <Toolbar>
        <ToolbarLeft>
          <FilterButton active={activeChips.length > 0} onClick={openFilter}>
            <MdTune />
            필터
            {activeChips.length > 0 && <CountBadge>{activeChips.length}</CountBadge>}
          </FilterButton>
        </ToolbarLeft>
        <ToolbarRight>
          <ToolbarBtn onClick={() => {
            setText("")
            getAllUsers()
          }}>
            전체 보기
          </ToolbarBtn>
          <StyledForm onSubmit={(e) => onSubmit(e, text)}>
            <InputBlock>
              <StyledInput
                placeholder="이름 or 전화번호"
                onChange={(e) => {
                  setText(e.target.value);
                  onChange(e);
                }}
                name="keyword"
                value={text}
                autoComplete="off"
                autoFocus
              ></StyledInput>
              <GoSearch onClick={() => onClickSearch(text)}/>
            </InputBlock>
          </StyledForm>
          <ToolbarIconBtn onClick={() => {
            setText("")
            getAllUsers()
          }}>
            <MdRefresh />
          </ToolbarIconBtn>
          <ToolbarBtn primary onClick={() => onRegist()}>
            회원 등록
          </ToolbarBtn>
        </ToolbarRight>
      </Toolbar>
      { activeChips.length > 0 &&
        <AppliedRow>
          <AppliedLabel>적용된 필터</AppliedLabel>
          {activeChips.map((chip, i) => (
            <Chip key={i}>
              <span className="key">{chip.key}</span>
              <span>{chip.text}</span>
              <button type="button" className="remove" aria-label="필터 제거" onClick={chip.clear}>
                <MdClose />
              </button>
            </Chip>
          ))}
        </AppliedRow>
      }
      { filterOpen &&
        <FilterModalOverlay onClick={() => setFilterOpen(false)}>
          <FilterModalCard onClick={(e) => e.stopPropagation()}>
            <FilterModalHeader>
              <h3>회원 필터</h3>
              <button type="button" className="close" aria-label="닫기" onClick={() => setFilterOpen(false)}>
                <MdClose />
              </button>
            </FilterModalHeader>
            <FilterModalBody>
              <FilterSection>
                <SectionLabel>정렬</SectionLabel>
                <PillGroup>
                  {options.map((o) => (
                    <Pill key={o.value} selected={draftSort === o.value} onClick={() => setDraftSort(o.value)}>
                      {o.label}
                    </Pill>
                  ))}
                </PillGroup>
              </FilterSection>
              <FilterSection>
                <SectionLabel>성별</SectionLabel>
                <PillGroup>
                  {sexOptions.map((o) => (
                    <Pill key={o.value || 'all'} selected={draftSex === o.value} onClick={() => setDraftSex(o.value)}>
                      {o.label}
                    </Pill>
                  ))}
                </PillGroup>
              </FilterSection>
              <FilterSection>
                <SectionLabel>회원 상태</SectionLabel>
                <PillGroup>
                  {stateOptions.map((o) => (
                    <Pill key={o.value || 'all'} selected={draftState === o.value} onClick={() => setDraftState(o.value)}>
                      {o.label}
                    </Pill>
                  ))}
                </PillGroup>
              </FilterSection>
              <FilterSection>
                <SectionLabel>회원권 종류 <SectionHint>중복 선택 가능</SectionHint></SectionLabel>
                <MembershipPillGroup>
                  {membershipTitleOptions.map((o) => {
                    const isAll = o.value === '';
                    const selected = isAll ? draftTitles.length === 0 : draftTitles.includes(o.value);
                    return (
                      <Pill
                        key={o.value || 'all'}
                        selected={selected}
                        onClick={() => {
                          if (isAll) { setDraftTitles([]); return; }
                          setDraftTitles((prev) => (prev.includes(o.value) ? prev.filter((x) => x !== o.value) : [...prev, o.value]));
                        }}
                      >
                        {o.label}
                      </Pill>
                    );
                  })}
                </MembershipPillGroup>
              </FilterSection>
            </FilterModalBody>
            <FilterModalFooter>
              <ResetButton type="button" onClick={resetDraft}>초기화</ResetButton>
              <ApplyButton type="button" onClick={applyFilter}>적용하기</ApplyButton>
            </FilterModalFooter>
          </FilterModalCard>
        </FilterModalOverlay>
      }
      <MemberTable>
        <MemberTableHeader>
          <tr>
            <td width="10%">이름</td>
            <td width="6%">나이</td>
            <td width="8%">성별</td>
            <td width="15%">연락처</td>
            <td width="13%">가입일</td>
            <td width="21%">회원권</td>
            <td width="6%">상태</td>
            <td width="20%">기간</td>
          </tr>
        </MemberTableHeader>
        <MemberTableBody style={loading? {display: 'none'} : {}}>
          { list ? list.map((member) => {
            const hasMobile = member.repPaymentID && member.repPaymentID !== "";
            return(
              <tr key={member.playerID} onClick={() => onClick(member)}>
                <td width="10%">
                  {   faceActive == 1 && member.faceURL &&
                      // <img src={FaceIcon} alt="face" style={{width: '20px', height: '20px', borderRadius: '50%', marginLeft: '-30px', marginRight: '10px', marginBottom: '-5px', color: palette.webCyan[5]}} />
                      <FaceIcon
                          style={{
                              width: '20px',
                              height: '20px',
                              marginLeft: '-30px',
                              marginRight: '10px',
                              marginBottom: '-5px',
                              fill: palette.webCyan[5] // 원하는 색상
                          }}
                      />
                  }
                  {member.name}
                </td>
                <td width="6%">{member.age}</td>
                <td width="8%">{member.sex}</td>
                <td width="15%">{member.phone}</td>
                <td width="13%">{timeValueToDate(member.registTime)}</td>
                <td width="21%">
                  <MemberShipTilte title={hasMobile ? "모바일 구매" : "현장 구매"}>
                    {member.repTitle ? member.repTitle : "-"}
                    {hasMobile && <MdSmartphone />}
                  </MemberShipTilte>
                </td>
                <td width="6%">
                  {classificationRepState(member.repState)}
                </td>
                <td width="20%">
                  {member.repEndTime
                    ? `${timeValueToDate(member.repStartTime)} ~ ${timeValueToDate(member.repEndTime)}`
                    : "-"}
                </td>
              </tr>
            )
          }) : "" }
        </MemberTableBody>
      </MemberTable>
      {loading && 
        <div style={{width: '100%', height: '780px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          <Ring />
        </div>
      }
      <div style={{display: 'flex', width: '100%', marginTop: '40px', alignItems: 'center', justifyContent: 'center', gap: '14px'}}>
        <Pagination
          count={Math.ceil(memberCount / 20)}
          page={page}
          size="large"
          showFirstButton
          showLastButton
          onChange={(event, value) => {if(value !== page) {
            setPage(value)
            onChangePage(value)
          }}}
        />
        <GoToPageButton onClick={openGoToPageModal}>페이지 이동</GoToPageButton>
      </div>
    </MemberBlock>
  );
};

export default React.memo(MemberList);
